import { useEffect, useState } from "react";
import { Download, Share, Smartphone, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallAppButton = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); };
    const onInstalled = () => { setInstalled(true); setPromptEvent(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || (!promptEvent && !isIos())) return null;

  const handleClick = async () => {
    if (promptEvent) {
      promptEvent.prompt();
      const { outcome } = await promptEvent.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setPromptEvent(null);
    } else {
      setShowIosHelp(true);
    }
  };

  return (
    <>
      <Button size="sm" onClick={handleClick} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="install-app-button">
        <Download className="w-4 h-4 sm:mr-2" />
        <span className="hidden sm:inline">Installer l'application</span>
      </Button>
      {showIosHelp && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 flex items-end sm:items-center justify-center p-4" onClick={() => setShowIosHelp(false)} data-testid="ios-install-help">
          <div className="bg-white rounded-2xl max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center"><Smartphone className="w-5 h-5 text-orange-600" /></div>
                <h3 className="font-heading font-bold text-slate-900">Installer sur iPhone / iPad</h3>
              </div>
              <button onClick={() => setShowIosHelp(false)} className="p-1 text-slate-400 hover:text-slate-600" data-testid="ios-install-close"><X className="w-5 h-5" /></button>
            </div>
            <ol className="space-y-3 text-sm text-slate-600 list-decimal pl-5">
              <li>Ouvrez cette page dans <strong>Safari</strong>.</li>
              <li>Touchez le bouton <strong>Partager</strong> <Share className="inline w-4 h-4 text-blue-600" /> en bas de l'écran.</li>
              <li>Choisissez <strong>« Sur l'écran d'accueil »</strong> puis <strong>Ajouter</strong>.</li>
            </ol>
            <p className="text-xs text-slate-400 mt-4">L'icône DevisMaison apparaîtra sur votre écran d'accueil comme une application.</p>
          </div>
        </div>
      )}
    </>
  );
};
